import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { Loading, ModalContainer } from "web/components"
import { AppProviders, LibraryProviders } from "web/Providers"
import FormSectionsList from "web/app/Settings/Customization/FormSections/List"

export default class ListFormSectionsController extends Controller {
  static values = {
    subjectType: String,
    topicId: Number,
  }

  initialize() {
    global.React = React
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }

  connect() {
    const topicId = this.topicIdValue || null

    render(
      <Suspense fallback={<Loading />}>
        <LibraryProviders>
          <AppProviders>
            <FormSectionsList
              subjectType={this.subjectTypeValue}
              topicId={topicId}
            />
            <ModalContainer />
          </AppProviders>
        </LibraryProviders>
      </Suspense>,
      this.element
    )
  }
}
